import createBlockViewObservers from './blockView';
import pageScroll from './pageScroll';

export default () => {
  createBlockViewObservers();
  pageScroll();
}
